// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';

import DomainTrusteeOption from './DomainTrusteeOption';
import { PremiumDNSRenew } from './PremiumDNSRenew';
import ProductItem from './components/ProductItem';

type Props = { product: DecoratedProduct };

export function DomainOptionDefault({ product }: Props): React.MixedElement {
  if (product.description === 'trustee')
    return <DomainTrusteeOption product={product} />;

  if (product.description === 'premium_dns')
    return <PremiumDNSRenew product={product} />;

  return (
    <ProductItem
      key={`${product.id}-row`}
      hasTaxes={product.hasTaxes}
      priceBeforeTaxes={product.unitPrice}
      label={product.label || ''}
      productId={product.id}
    />
  );
}
